import { useContext } from "react";
import { UserContext } from "../Context/UserContextAPI";

const useQrCodeUrl = (user) => {
  const { settingsData } = useContext(UserContext);
  const currentUrl = process.env.REACT_APP_QC_PASSED_URL;
  if (settingsData && settingsData?.qr_code_type === 1) {
    return `${currentUrl}/medical-verification/result/report/print/${user?.id || user?.user_id}`;
  }
  return settingsData?.qrcode_url;
};
export default useQrCodeUrl;
